import React from "react";

export default function GlowingDot({ style = {} }) {
  return <div style={style} className="glowing-circle"></div>;
}
